let getNewAccessToken: (() => Promise<string>) | null = null;
export const setRefreshPromise = (promise: (() => Promise<string>) | null) => {
  getNewAccessToken = promise;
  return;
};

let sharedRefreshPromise: Promise<string> | null = null;

export const getRefreshPromise = (): Promise<string> | null => {
  if (!getNewAccessToken) {
    return null;
  }

  if (!sharedRefreshPromise) {
    sharedRefreshPromise = getNewAccessToken().finally(() => {
      sharedRefreshPromise = null;
    });
  }
  const fixedRefreshPromise = sharedRefreshPromise;

  return new Promise<string>((resolve, reject) => {
    fixedRefreshPromise
      .then((token) => {
        resolve(token);
        return token;
      })
      .catch((e) => {
        reject(e);
        throw e;
      });
  });
};
